"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var InlineAlert = function InlineAlert(_ref) {
  var alert = _ref.alert,
    dismissAlert = _ref.dismissAlert,
    style = _ref.style;
  return alert.message ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert alert-".concat(alert.alertType),
    style: style
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert-message"
  }, alert.message), /*#__PURE__*/_react["default"].createElement("div", {
    className: "alert-clear"
  }, alert.dismissible && /*#__PURE__*/_react["default"].createElement("i", {
    className: "material-icons pull-right",
    style: {
      color: 'red'
    },
    onClick: dismissAlert
  }, "clear"))) : /*#__PURE__*/_react["default"].createElement("div", null);
};
InlineAlert.propTypes = {
  alert: _propTypes["default"].object.isRequired,
  dismissAlert: _propTypes["default"].func.isRequired,
  style: _propTypes["default"].object
};
var _default = exports["default"] = InlineAlert;